import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';

import MainLayout from './layouts/Main.vue';
import Login from './layouts/Login.vue';
import Home from './views/Home.vue';
import UserManagement from './views/UserManagement.vue';
import ManageUsers from './views/Users/Manage/Index.vue';
import ClientManageGroup from './views/ClientManageGroup.vue';
import LmsAdmin from './views/LmsAdmin.vue';
import SecretshopManagement from './views/SecretshopManagement.vue';
import InternetShopForm from './views/InternetShopForm.vue';
import ClientLmsPlaylist from './views/ClientLmsPlaylistUnit.vue';
import ModulePage from './views/ClientLmsModule.vue';
import CategoryPage from './views/ClientLmsCategoryPage.vue';
import ClientShops from './views/ClientShops.vue';
import InternetShop from './views/InternetShop.vue';
import ClientReport from './views/ClientReport.vue';
import PhoneShop from './views/PhoneShop.vue';
import GroupShop from './views/GroupShop.vue';
import ClientProfile from './views/ClientProfile.vue';
import ClientLmsSummaryReport from './views/ClientLmsSummaryReport.vue';
import NotFound from './views/NotFound.vue';
import Playlist from './views/Playlist.vue';
import QuizBuilder from './components/lms-admin/quiz-builder/QuizBuilder.vue';
import SearchResult from './views/SearchResult.vue';
import PhoneShopGuestView from './views/Guest/Phoneshop.vue';
import InternetShopGuestView from './views/Guest/InternetShop.vue';
import GuestGroupShop from './components/secretshop/GroupShop/GuestGroupShop.vue';
import PlaylistPage from './views/PlaylistsPage.vue';
import AssignedUnits from './views/AssignedUnitsPage.vue';
import FavoritesPage from './views/FavoritesPage.vue';
import MostSearched from './views/MostSearchedPage.vue';
import ExportLog from './components/client-shops/ExportLog.vue';
import ClientCoursePage from './components/course-certification/CoursePage.vue';
import PreviewUnit from '@/components/client-lms/UnitPage/PreviewUnit';
import EditUnit from './components/client-lms/UnitPage/EditUnit';

import CurriculumPage from '@/components/lms-admin/includes/CurriculumPage';
import ConfigurePricingPage from '@/components/lms-admin/includes/ConfigurePricingPage';

import store from './store/index';
import CertificateModulePage from '@/components/course-certification/CertificateModulePage';
import AssignedAndSharedContents from '@/views/LMS/AssignedAndSharedContents';

import oldLogin from './layouts/oldLogin';
import ListEvents from '@/views/Events/ListEvents';

import RecentVideos from './views/RecentVideos';
import FeaturedVideo from '@/components/client-home/lms/FeaturedVideo';
import DetailedReport from './components/client-reports/progress-report/DetailedReport';

import CompanyAdvanceSettings from './components/company-settings/CompanyAdvanceSettings';
import HomeLoading from './views/HomeLoading.vue';
import MaintenanceView from './views/Maintenance.vue';
import PreLogin from './views/PreLogin.vue';
import CreateCustomForm from './views/CustomForms/CreateCustomForm.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: ['staging', 'production'].includes(process.env.NODE_ENV)
    ? '/'
    : process.env.BASE_URL,
  routes: [
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: MaintenanceView,
    },
    {
      path: '/guest/phone-shop/:id?',
      name: 'PhoneShopGuestView',
      component: PhoneShopGuestView,
    },
    {
      path: '/guest/internet-shop/:id?',
      name: 'InternetShopGuestView',
      component: InternetShopGuestView,
    },
    {
      path: '/export-log',
      name: 'ExportLog',
      component: ExportLog,
    },
    {
      path: '/guest/group-shop/:id?',
      name: 'GroupShopGuestView',
      component: GuestGroupShop,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: Login,
      meta: {
        auth: false,
      },
    },
    {
      path: '/login/:token?',
      component: Login,
      name: 'Login',
    },
    {
      path: '/pre-login',
      component: PreLogin,
      name: 'pre-login',
    },
    {
      path: '/disable-sso-login/:token?',
      component: oldLogin,
      name: 'disable-sso-login',
    },
    {
      path: '/',
      component: MainLayout,
      meta: {
        auth: true,
      },
      children: [
        {
          path: '/admin/dashboard',
          name: 'Dashboard',
          component: Home,
          icon: 'fal fa-tachometer',
          meta: {
            allowed: ['super-administrator'],
          },
        },
        {
          path: '/lms-admin',
          name: 'LMS Management',
          component: LmsAdmin,
          icon: 'fal fa-users-class',
          meta: {
            allowed: [
              'super-administrator',
              'account-manager',
              'specific-dealer-manager',
            ],
          },
        },
        {
          path: '/company-settings',
          name: 'Company Settings',
          component: CompanyAdvanceSettings,
          meta: {
            allowed: [
              'super-administrator',
              'account-manager',
              'specific-dealer-manager',
            ],
          },
        },
        {
          path: '/lms-admin/quiz-builder/:id?',
          name: 'Quiz Builder',
          component: QuizBuilder,
        },
        {
          path: '/lms-admin/curriculum/:id?',
          name: 'CurriculumPage',
          component: CurriculumPage,
        },
        {
          path: '/lms-admin/curriculum/configure/:id?',
          name: 'ConfigurePricingPage',
          component: ConfigurePricingPage,
        },
        {
          path: '/secretshop-management',
          name: 'Secret Shop Management',
          component: SecretshopManagement,
          icon: 'fal fa-analytics',
          meta: {
            allowed: ['secret-shopper', 'super-administrator'],
          },
        },
        {
          path: '/detailed/report',
          component: DetailedReport,
          name: 'DetailedReport',
        },
        {
          path: '/secretshop-management/internet-shop',
          name: 'Internet Shop Form',
          component: InternetShopForm,
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/secretshop-management/internet-shop/:id',
          name: 'Internet Shop Form Update',
          component: InternetShopForm,
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/company-management',
          name: 'Manage Companies',
          component: UserManagement,
          icon: 'fal fa-users-crown',
          meta: {
            allowed: ['super-administrator'],
          },
        },
        {
          path: '/manage/users',
          name: 'Manage Users',
          component: ManageUsers,
          icon: 'fal fa-users',
          meta: {
            allowed: ['super-administrator'],
          },
        },
        {
          path: '/manage/groups',
          name: 'Manage Group',
          component: ClientManageGroup,
          icon: 'fal fa-users',
          meta: {
            allowed: ['super-administrator'],
          },
        },
        {
          path: '/client/lms-summary-report',
          name: 'LMS Summary Report',
          component: ClientLmsSummaryReport,
          icon: 'fal fa-user-circle',
        },
        {
          path: '/client/profile',
          name: 'My Profile',
          component: ClientProfile,
          icon: 'fal fa-user-circle',
        },
        {
          path: '/',
          name: 'Secret Shop Home',
          component: HomeLoading,
          icon: 'fal fa-home',
        },
        {
          path: '/client/lms/assigned-and-shared-contents',
          name: 'LMS Assigned And Shared Contents',
          component: AssignedAndSharedContents,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/shops',
          name: 'Secret Shops',
          component: ClientShops,
          icon: 'fal fa-user-secret',
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/preview/unit/:id',
          name: 'PreviewUnitPage',
          component: PreviewUnit,
          meta: {
            product: 'LMS',
            allowed: [
              'super-administrator',
              'account-manager',
              'specific-dealer-manager',
            ],
          },
        },
        {
          path: '/edit/unit/:id',
          name: 'EditUnitPage',
          component: EditUnit,
          meta: {
            product: 'LMS',
            allowed: [
              'super-administrator',
              'account-manager',
              'specific-dealer-manager',
            ],
          },
        },
        {
          path: '/client/lms/playlist/:playlistId/unit/:id',
          name: 'PlaylistUnitPage',
          component: ClientLmsPlaylist,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/certification/module/:id',
          name: 'CertificationModulePage',
          component: CertificateModulePage,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/module/:id',
          name: 'ModulePage',
          component: ModulePage,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/reports',
          name: 'Report',
          component: ClientReport,
          icon: 'fal fa-user-chart',
          meta: {
            allowed: [
              'super-administrator',
              'account-manager',
              'specific-dealer-manager',
            ],
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/category/:id',
          name: 'Category Page',
          component: CategoryPage,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/course/:id',
          name: 'Course Page',
          component: ClientCoursePage,
          meta: {
            product: 'lms',
          },
        },
        {
          path: '/client/internet-shop/:id',
          name: 'InternetShop',
          component: InternetShop,
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/client/phone-shops/:id',
          name: 'PhoneShop',
          component: PhoneShop,
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/client/group-shops/:id',
          name: 'GroupShop',
          component: GroupShop,
          meta: {
            product: 'SecretShop',
          },
        },
        {
          path: '/client/lms/playlists',
          name: 'PlaylistsPage',
          component: PlaylistPage,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/assigned-units',
          name: 'AssignedUnits',
          component: AssignedUnits,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/favorites',
          name: 'FavoritesPage',
          component: FavoritesPage,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/client/lms/most-searched',
          name: 'MostSearched',
          component: MostSearched,
          meta: {
            product: 'LMS',
          },
        },

        {
          path: '/playlist/:id',
          name: 'Playlist',
          component: Playlist,
          meta: {
            product: 'LMS',
          },
        },
        {
          path: '/search/result',
          name: 'SearchResult',
          component: SearchResult,
        },
        {
          path: '/events',
          name: 'Events',
          component: ListEvents,
        },
        {
          path: '/recent-videos',
          name: 'Recent Videos',
          component: RecentVideos,
        },
        {
          path: '/featured-video',
          name: 'Featured Video',
          component: FeaturedVideo,
        },
        {
          path: '/internet-shops/custom-forms',
          name: 'CreateInternetShopCustomForm',
          component: CreateCustomForm,
        }
      ],
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: NotFound,
    },
  ],
});

function checkToken(next, to) {
  const bearerToken = router.app.$auth.token();
  return axios
    .get('/api/user', {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    })
    .then(() => {
      next();
    })
    .catch(() => {
      next({
        name: `${to.name}GuestView`,
        params: {
          id: to.params.id,
        },
      });
    });
}

router.beforeEach(async (to, from, next) => {
  // this will let the user/guest view the "shops" page
  if (['InternetShop', 'PhoneShop', 'GroupShop'].includes(to.name)) {
    await checkToken(next, to);
  }

  next();
});

Vue.router = router;

export default router;
